/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { subnetReplicaVersionsGetApiV3SubnetReplicaVersions } from "../../funcs/subnetReplicaVersionsGetApiV3SubnetReplicaVersions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3SubnetReplicaVersionsRequest$inboundSchema
    .optional(),
};

export const tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersions:
  ToolDefinition<typeof args> = {
    name: "subnet-replica-versions-get-api-v3-subnet-replica-versions",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await subnetReplicaVersionsGetApiV3SubnetReplicaVersions(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
